module.exports = __webpack_public_path__ + "img/20200613_092759.4700a06f.jpg";